$.extend($.fn, {
  isBefore(sel, context) {
    const all = $(context || document).find('*');
    return all.index(this[0]) < all.index($(sel)[0]);
  },
});
